import { cva } from 'class-variance-authority';
export const cvaBadge = cva(['BadgeStyles-cvaBadge', 'mb-[1.6rem]']);

export const cvaBadgeName = cva([
  'BadgeStyles-cvaBadgeName',
  'mb-0.8',
  'text-header-s',
]);

export const cvaBadgePhone = cva([
  'BadgeStyles-cvaBadgePhone',
  'text-m-sb text-cGray ',
]);
